module.exports = __webpack_public_path__ + "img/infinity-kingdom.0ef0be3.png";